exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer.front{background:#23180a}footer.front .copyright{color:#fff;margin:0;padding:0!important}footer.front .policy{margin:0;padding:0!important;text-align:right}footer.front .policy a.link{color:#fff;margin-right:30px;cursor:pointer;text-decoration:underline}footer.front .policy a.link:last-child{margin-right:0}@media (max-width:991px){footer.front .copyright,footer.front .policy{text-align:center}}@media (max-width:375px){footer.front .policy a.link{margin-right:15px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0489bd72","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Front/Footer/index.vue
// module id = 1010
// module chunks = 0